module.exports = __webpack_public_path__ + "2703deb6572affa312f20b5c67966a27.jpg";